import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const ReferralRedirect = () => {
  const { referralCode } = useParams();
  if (referralCode) {
    localStorage.setItem('refcode', referralCode);
  }
  return <Navigate to="/" replace />;
};

const Landing = React.lazy(() => import('./Landing'));
const ConfirmEmail = React.lazy(() => import('./ConfirmEmail'));
const ReferralProgram = React.lazy(() => import('./ReferralProgram'));
const S1Dashboard = React.lazy(() => import('./S1/Dashboard'));
const S1Leaderboard = React.lazy(() => import('./S1/Leaderboard'));
const Leaderboard = React.lazy(() => import('./Leaderboard'));
// ARCHIVED: Liquidity Airdrop - Season 11
// const LiquidityAirdrop = React.lazy(() => import('./LiquidityAirdrop'));
// ARCHIVED: Creator Airdrop - Season 11
// const CreatorAirdrop = React.lazy(() => import('./CreatorAirdrop'));
const TraderAirdrop = React.lazy(() => import('./TraderAirdrop'));
const Dashboard = React.lazy(() => import('./Dashboard'));
const Boosters = React.lazy(() => import('./Boosters'));
// HIDDEN: Token Hodler Airdrop (hidden from UI)
// const TokenHodler = React.lazy(() => import('./TokenHodler'));
// ARCHIVED: NFT Hodler - Season 12 (will re-add later)
// const NftHodler = React.lazy(() => import('./NftHodler'));
const ZealyAirdrop = React.lazy(() => import('./ZealyAirdrop'));
// ARCHIVED: Marketplace Volume Airdrop - Season 11
// const NftVolumeAirdrop = React.lazy(() => import('./NftVolumeAirdrop'));
const NftBridgeAirdrop = React.lazy(() => import('./NftBridgeAirdrop'));
// ARCHIVED: Portfolio Airdrop - Season 12
// const NftPortfolioAirdrop = React.lazy(() => import('./NftPortfolioAirdrop'));
const NftListingAirdrop = React.lazy(() => import('./NftListingAirdrop'));
const MintingAirdrop = React.lazy(() => import('./MintingAirdrop'));
// ARCHIVED: Power Tweet Airdrop - Season 11
// const PowerTweetAirdrop = React.lazy(() => import('./PowerTweetAirdrop'));
const RewardsVault = React.lazy(() => import('./RewardsVault'));
const MemeCreatorAirdrop = React.lazy(() => import('./MemeCreatorAirdrop'));
const ReferralStats = React.lazy(() => import('./ReferralStats'));
const SingleReferralStats = React.lazy(() => import('./ReferralStats/SingleReferralStats'));
const ReferralProgramContest = React.lazy(() => import('./ReferralProgramContest'));
const EasyWins = React.lazy(() => import('./EasyWins'));
const PowerUserPrograms = React.lazy(() => import('./PowerUserPrograms'));
// ARCHIVED Season 14: Tweet To Earn (temporarily removed — easy to bring back)
// const XDashboard = React.lazy(() => import('./XDashboard'));

export const ROUTES = {
  // Dashboard is now the root route
  Landing: '/welcome', // Landing page moved to welcome route
  ConfirmEmail: '/confirm-email',
  EmailVerified: '/email-verified',
  Referral: '/referral',
  S1Dashboard: '/s1',
  S1Leaderboard: '/s1/leaderboard',
  Dashboard: '/', // Dashboard is now at root
  Leaderboard: '/leaderboard',
  // ARCHIVED Season 14: Tweet To Earn (temporarily removed — easy to bring back)
  // TweetToEarn: '/tweet-to-earn',
  // ARCHIVED: Liquidity Airdrop - Season 11
  // LiquidityAirdrop: '/liquidity-airdrop',
  // ARCHIVED: Creator Airdrop - Season 11
  // CreatorAirdrop: '/creator-airdrop',
  TraderAirdrop: '/trader-airdrop',
  // HIDDEN: Token Hodler Airdrop (hidden from UI)
  // TokenHodler: '/token-hodler',
  // ARCHIVED: NFT Hodler - Season 12 (will re-add later)
  // NftHodler: '/nft-hodler',
  Boosters: '/boosters',
  ZealyAirdrop: '/zealy-airdrop',
  // ARCHIVED: Marketplace Volume Airdrop - Season 11
  // NftVolumeAirdrop: '/nft-volume',
  NftBridgeAirdrop: '/nft-bridge-airdrop',
  // ARCHIVED: Portfolio Airdrop - Season 12
  // NftPortfolioAirdrop: '/portfolio-airdrop',
  NftListingAirdrop: '/listing-airdrop',
  MintingAirdrop: '/minting-airdrop',
  // ARCHIVED: Power Tweet Airdrop - Season 11
  // PowerTweetAirdrop: '/power-tweet-airdrop',
  RewardsVault: '/rewards-vault',
  MemeCreatorAirdrop: '/meme-creator-airdrop',
  ReferralStats: '/referral-stats',
  SingleReferralStats: '/my-referral-stats',
  ReferralProgramContest: '/referral-contest',
  EasyWins: '/easy-wins',
  PowerUserPrograms: '/power-user-programs',
};

export const PAGES = [
  {
    path: ROUTES.Dashboard, // Dashboard is now at root path '/'
    element: <Dashboard />,
  },
  {
    path: ROUTES.Landing, // Landing page is now at '/welcome'
    element: <Landing />,
  },
  {
    path: ROUTES.S1Dashboard,
    element: <S1Dashboard />,
  },
  {
    path: ROUTES.S1Leaderboard,
    element: <S1Leaderboard />,
  },
  {
    path: ROUTES.Referral,
    element: <ReferralProgram />,
  },
  {
    path: ROUTES.Leaderboard,
    element: <Leaderboard />,
  },
  {
    path: ROUTES.ConfirmEmail,
    element: <ConfirmEmail />,
  },
  // ARCHIVED Season 14: Tweet To Earn (temporarily removed — easy to bring back)
  // {
  //   path: ROUTES.TweetToEarn,
  //   element: <XDashboard />,
  // },
  // ARCHIVED: Liquidity Airdrop - Season 11
  // {
  //   path: ROUTES.LiquidityAirdrop,
  //   element: <LiquidityAirdrop />,
  // },
  // ARCHIVED: Creator Airdrop - Season 11
  // {
  //   path: ROUTES.CreatorAirdrop,
  //   element: <CreatorAirdrop />,
  // },
  {
    path: ROUTES.TraderAirdrop,
    element: <TraderAirdrop />,
  },
  {
    path: ROUTES.Boosters,
    element: <Boosters />,
  },
  // HIDDEN: Token Hodler Airdrop (hidden from UI)
  // {
  //   path: ROUTES.TokenHodler,
  //   element: <TokenHodler />,
  // },
  // ARCHIVED: NFT Hodler - Season 12 (will re-add later)
  // {
  //   path: ROUTES.NftHodler,
  //   element: <NftHodler />,
  // },
  {
    path: ROUTES.ZealyAirdrop,
    element: <ZealyAirdrop />,
  },
  // ARCHIVED: Marketplace Volume Airdrop - Season 11
  // {
  //   path: ROUTES.NftVolumeAirdrop,
  //   element: <NftVolumeAirdrop />,
  // },
  {
    path: ROUTES.NftBridgeAirdrop,
    element: <NftBridgeAirdrop />,
  },
  // ARCHIVED: Portfolio Airdrop - Season 12
  // {
  //   path: ROUTES.NftPortfolioAirdrop,
  //   element: <NftPortfolioAirdrop />,
  // },
  {
    path: ROUTES.NftListingAirdrop,
    element: <NftListingAirdrop />,
  },
  {
    path: ROUTES.MintingAirdrop,
    element: <MintingAirdrop />,
  },
  // ARCHIVED: Power Tweet Airdrop - Season 11
  // {
  //   path: ROUTES.PowerTweetAirdrop,
  //   element: <PowerTweetAirdrop />,
  // },
  {
    path: ROUTES.RewardsVault,
    element: <RewardsVault />,
  },
  {
    path: ROUTES.MemeCreatorAirdrop,
    element: <MemeCreatorAirdrop />,
  },
  {
    path: ROUTES.ReferralStats,
    element: <ReferralStats />,
  },
  {
    path: ROUTES.SingleReferralStats,
    element: <SingleReferralStats />,
  },
  {
    path: ROUTES.ReferralProgramContest,
    element: <ReferralProgramContest />,
  },
  {
    path: ROUTES.EasyWins,
    element: <EasyWins />,
  },
  {
    path: ROUTES.PowerUserPrograms,
    element: <PowerUserPrograms />,
  },
  {
    path: '/:referralCode',
    element: <ReferralRedirect />,
  },
];

export const NAV_LINKS = [
  {
    name: 'Airdrop Dashboard',
    path: ROUTES.Dashboard,
  },
  {
    name: 'Rewards Vault',
    path: ROUTES.RewardsVault,
  },
  {
    name: 'Referral Program',
    path: ROUTES.Referral,
  },
  {
    name: 'Referral Stats',
    path: ROUTES.ReferralStats,
  },
  {
    name: 'GMI Marketplace',
    path: 'https://gonnamakeit.com/',
  },
  {
    name: 'Resources',
    path: '',
    submenus: [
      {
        name: 'Collections',
        path: 'https://app.gonnamakeit.com/collections?type=top',
      },
      {
        name: 'Stats',
        path: 'https://gonnamakeit.com/stats',
      },
      {
        name: 'Litepaper',
        path: 'https://gonnamakeit.com/lite-paper',
      },
      {
        name: 'For Investors',
        path: 'https://info.gonnamakeit.com/for-investors/',
      },
      {
        name: 'FAQ',
        path: 'https://gonnamakeit.com/faq',
      },
      {
        name: 'Docs',
        path: 'https://docs.gonnamakeit.com/',
      },
      {
        name: 'Help Center',
        path: 'https://discord.com/channels/398355554172534805/1157987899246137384',
      },
      {
        name: 'Energi Website',
        path: 'https://energi.world/',
      },
    ],
  },
];
